import AddIcon from '@mui/icons-material/Add'
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna'
import { Box, Button, Container, Typography } from '@mui/material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AlertComponent } from 'src/components/Alert/AlertComponent'
import ActivityHistory from 'src/components/SideMenuAudit/ActivityHistory'
import { ActivityContext } from 'src/context/ActivityContext'
import useProtectedPage from 'src/hooks/useProtectedPage'
import { getPermissions } from 'src/service/authService'
import { goToCreatePoint } from '../../routes/coordinator'
import PointTable from './components/Table/PointTable'

const Point = () => {
  useProtectedPage()
  const history = useNavigate()
  const { t } = useTranslation()
  const { openDrawer } = useContext(ActivityContext)

  const permissions = JSON.parse(getPermissions())

  return (
    <Container
      sx={{
        mt: '96px',
      }}
    >
      <AlertComponent />
      <Box
        component="div"
        sx={{
          color: '#FF5E1E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '24px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <SettingsInputAntennaIcon />
          <Typography
            variant="h6"
            sx={{
              fontWeight: '500',
              fontSize: '20px',
              lineHeight: '160%',
              letterSpacing: ' 0.15px',
              color: ' #FF5E1E',
              marginTop: '-4px',
            }}
          >
            {t('point.title')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {
            permissions?.auditory?.includes('auditory:list') && <ActivityHistory path="pontos" keySubtitle="apName" />
          }
        </Box>
      </Box>

      <Box
        sx={{
          mb: '40px',
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row',
          },
          gap: '16px',
          width: openDrawer ? 'calc(100% - 280px)' : '100%',
        }}
      >
        <Button
          onClick={() => goToCreatePoint(history)}
          disabled={!permissions?.accesspoint?.includes("accesspoint:create")}
          variant="outlined"
          sx={{
            gap: '6px',
            width: openDrawer ? '100%' : '49%',
            height: '36px',
            ':hover': {
              backgroundColor: '#FF5E1E',
              color: '#ffff',
            },
          }}
        >
          <AddIcon /> {t('point.button.create')}
        </Button>
      </Box>

      <PointTable />
    </Container>
  )
}
export default Point
